module.exports = __webpack_public_path__ + "img/banner-001.906ce2c2.png";